import { FLAG_RTK_ROSTERING_DEPRECATIONS } from '../constants';

const RTK_DEPRECATED_TITLES = ['Users', 'Data Imports', 'SAML Configuration', 'Integrations'];

const filterMenuAccordingToIntegration = (menuItemsAsJson, district, userInfo, featureFlags = {}) => {
    const rosteringDeprecated = featureFlags[FLAG_RTK_ROSTERING_DEPRECATIONS] === true;

    const filteredMenuItemsAsJson = menuItemsAsJson.map(item => {
        if (item.title === 'Manage') {
            let links;
            if (userInfo.role === 'SCHOOL_ADMIN') {
                if (district.integrationType === 'ONE_ROSTER') {
                    links = item.links.filter(link => link.title === 'Users' || link.title === 'Assessment Reports');
                } else {
                    links = item.links.filter(link => link.title === 'Assessment Reports');
                }
            } else if (district.integrationType === 'ONE_ROSTER') {
                links = item.links.filter(link => link.title !== 'Integrations');
            } else {
                links = item.links.filter(
                    link =>
                        link.title !== 'Data Imports' && link.title !== 'Users' && link.title !== 'SAML Configuration',
                );
            }

            if (rosteringDeprecated) {
                links = links.filter(link => !RTK_DEPRECATED_TITLES.includes(link.title));
            }

            return { ...item, links };
        }
        return item;
    });
    return filteredMenuItemsAsJson.filter(item => item !== null);
};

export default filterMenuAccordingToIntegration;
